/**
 *Created by jmmartinez on 24/09/2020
 * 30/09/2020 v2.0  Cambiado a framework2
 * 01/10/2020 v2.1 Añadida gestión de coloreador de columna.
 * 05/10/2020 v2.2 Añadido el uso de propiedades.filaSeleccionada para colorear el row.
 * 20/10/2020 V2.3 Añadido getIconRenderer
 *                 Uso en getFormatter de mostrarFilaActiva.
 * 20/11/2020 V2.4 Modificado el COLOR_CELL_SELECCIONADA
 *                 Añadida funcion getValorMulticampo
 *                 Modificado getFormatter para tener en cuenta si es una columna normal o multicampo.
 *                 Modificado getFormatter para poner en propiedades el valor calculado anteriormente en la variable "valor".
 * 22/11/2020 v2.5 Añadimos a propiedades la propiedad mostrarCeldaActiva.
 *                 En el método getEstilo, coloreamos la celda si propiedades.mostrarCeldaActiva y es la celdaActiva
 * 03/12/2020 v2.6 Añadido getCellCadenaCentroRenderer.
 *                 Modificado getCellSiNoRenderer para detectar que en vez de un booleano, en la propiedad viene una cadena.
 * 21/12/2020 v2.7 Añadida getCellIconoAccionRenderer para gestionar los CELLTIPO_ICONOACCION
 *                 Modificado getFormatter para tener en cuenta los CELLTIPO_ICONOACCION
 * 28/01/2020 v2.8 En getCellCadenaRender y CadenaVaciaRender, cuando es cadena vacía se renderiza: <span>&nbsp;</span>
 *                 En getStyloDeNivelYPie, asignamos por defecto: fontSize: '0.8em' y padding: '4px'
 * 05/02/2021 v2.9 Añadida gestión de CELLTIPO_IMAGENLISTA y la función getCellImagenLista
 * 22/02/2020 v2.10 En método getFormatter, en Propiedades añadimos columnIdx y columnKey para poder usarla en estilizadorRow del contenedor.
 *                 En método getEstilo, al llamar al estilizador, sólo pasamos de parámetro las propiedades
 * 09/03/2021 v2.11 Creamos método getCellLista para renderizar CELLTIPO_LISTA.
 *                 Modificamos método getFormatter para utilizar el método anterior
 * 24/03/2021 v2.12 Modificados los valores por defecto de fontSize= 0-7em en los estilos
 * 22/04/2021 v2.13 En el método getEstilo, añadido el caso de row Pie según propiedades.objeto.esPie
 * 30/04/2021 v2.14 Añadida la gestion de CELLTIPO_ICONOACCION_IMPRIMIR
 * 29/05/2021 v2.15 Modificada la funcion getValor para usar modificadorValorCelda
 *                  Modificado getFormatter para aplicar el valor calculado en getValor.
 * 16/06/2021 v2.16 Modificado getValor para meter dentro getValorMulticampo
 * 29/06/2021 v2.17 Modificada la funcion getCellMonedaRenderer para aplicar dos decimales fijos
 *
 * 02/08/2021 v2.20 Modificada getFormatter para tomar rowIdx: props.row.rowIdx,
 * 05/08/2021 v2.21 Añadida la gestión de CELLTIPO_IMAGENSINO
 *                  Modificado getEstiloDeNivelYPie para usar las cosntantes y no las cadenas en el case.
 *                  Modificado getCellImagenLista para no dar error al encontrar el campo imagen vacío.
 * 31/03/2022 v2.22 Modificado getValor, añadida condicion "key &&" para los casos en los que no hay key pq no hay campo en el gridConfig.
 *
 * 06/05/2022 v2.23 Union Planifikator y Sidemur
 * 19/05/2022 v2.24 En getFormatter, por si el tipo está vacío, cambiamos la asignación de tipo a:
 *                                                  tipo: props.column.tipo ? props.column.tipo.toUpperCase() : props.column.tipo,
 *                  En  en el else de if(valor != null) añadimos la condición de que exista el tipo.
 * 01/06/2022 v2.25 En getCellColorRenderer se ha añadido el dobleClick.
 * 07/07/2022 v2.26 Añadido controlador de CELLTIPO_CADENACENTRO_ACCIONCONDICIONVALOR
 * 27/07/2022 v2.27 En getFormatter añadida en propiedades: estilizadorRow
 *                  En getEstilo, cambiado el orden de aplicación de estilos y estilos acumulativos.
 *
 * 27/01/2023 v2.28 Añadido en getFormatter, en propiedades: ocultarCeros.
 *                  En getCellEnteroRenderer, añadida la funcionalidad de ocultarCeros.
 *                  Añadida gestion de CELLTIPO_ENTERO_CENTRO.
 *                  Creada funcion asignarTextAlignPorTipo.
 *                  Modificado getEstilo y getEstiloDeNivelYPie para usar asignarTextAlignPorTipo
 * 21/04/2023 v2.29 En getCellSiNoRenderer añadido onClick en el div
 * 24/04/2023 v2.30 Añadida gestión de CELLTIPO_MODIFICARROW
 * 25/04/2023 v2.31 Añadida gestión de CELLTIPO_ELIMINARROW
 * 18/05/2023 v2.32 Añadida gestión de CELLTIPO_CADENA_COLORES.
 *                  En getFormatter, añadido el campo listaColores.
 * 25/05/2023 v2.33 Añadido el tratamiento en las columnas de la propiedad onToolTip
 *                  Modificado el getCellIconoAccionRenderer para soportar el Tooltip
 *                  Modificado el getCellCadenaRenderer para soportar el Tooltip y mostrarTooltip
 * 13/07/2023 v2.34 Modificado dobleclick para detectar el click simple.
 *                                        En el click simple, si hay tooltip llamamos a propiedades.mostrarPopover para desdencadenar el proceso de mostrar el diálogo
 *
 *
 * 11/06/2023 v2.35 Añadida la gestión del tipo de celda: CELLTIPO_COMPONENTES con el método getCellComponentes
 *                  Añadido el campo onCalcularComponentesCelda en las propiedades.
 *                  Modificado método getEstilo, para añadir a la llamada a propiedades.estilizador, el parametro propiedades.columnKey
 *
 * 01/10/2024 v3.0 Modificado getCellMonedaRenderer para formatear la moneda: valor.toLocaleString(
 * 08/01/2025 v3.1 Modificado getCellFechaRenderer para poner "-" cuando la fecha sea 01/01/1900
 * 18/07/205  v3.2 Añadido formateo de CELLTIPO_HORA
 * */

import React from 'react'
import {esForeign, esForeign2Nivel, esForeignJPA, getValorDeForeign, getValorDeForeign2Nivel} from "../ej2/utils/ForeignUtils";
import {getValorPropiedad} from "../ej2/utils/ObjectUtils";
import {
    CELLTIPO_CADENA,
    CELLTIPO_CADENA_CENTRO,
    CELLTIPO_CADENA_COLORES,
    CELLTIPO_CANTIDAD,
    CELLTIPO_CHORA,
    CELLTIPO_COLOR,
    CELLTIPO_ENTERO,
    CELLTIPO_ENTERO_CENTRO,
    CELLTIPO_FECHA,
    CELLTIPO_FECHA_IZQUIERDA,
    CELLTIPO_FECHAHORA,
    CELLTIPO_FLOTANTE,
    CELLTIPO_ICONOACCION,
    CELLTIPO_ICONOACCION_DESCARGAR,
    CELLTIPO_ICONOACCION_ELIMINAR,
    CELLTIPO_ICONOACCION_VER,
    CELLTIPO_IMAGENLISTA,
    CELLTIPO_LISTA,
    CELLTIPO_MONEDA,
    CELLTIPO_PORCENTAJE,
    CELLTIPO_SINO,
    CELLTIPO_ICONO,
    CELLTIPO_ESTADOROW,
    CELLTIPO_ICONOACCION_IMPRIMIR,
    CELLTIPO_ICONOACCIONCONDICIONVALOR,
    CELLTIPO_FOREIGN,
    CELLTIPO_CADENACENTRO_ACCIONCONDICIONVALOR,
    CELLTIPO_MODIFICARROW,
    CELLTIPO_ELIMINARROW,
    CELLTIPO_COMPONENTES, CELLTIPO_HORA, CELLTIPO_MEMO,
} from "../ej2/UI/TiposCeldas";

import {
    getFormattedDateFromTimestamp,
    getFormattedDateTimeFromTimestamp,
    getFormattedTimeFromTimestamp
} from "../ej2/utils/DateUtils";
import {getStyleDeColoreador, getStyleDeNivelYPie} from "../blueprint/CellRenderers";
import {Icon, Radio, Tooltip, Classes} from "@blueprintjs/core";
import {filtrarConNombreCampo} from "../ej2/utils/FilterUtils";
import {Cell} from "@blueprintjs/table";
import {primerElementoCodigo} from "../ej2/utils/ArrayUtils";
import FechaCadenaInput from "../ej2/UI/FechaCadenaInput";
import {BOTONERA_ACCION_MODIFICAR} from "../ej2/UI/FormularioBotonera";
import {transformarCadenaColores} from "./Transformadores";

export const COLOR_ROW_IMPAR = '#f5f5f5';
export const COLOR_ROW_PAR = '#ffffff';
export const COLOR_CELL_SELECCIONADA = '#cccccc';
export const COLOR_ROW_PIE= '#bbbbbb';

const FONT_SIZE= "1em";

export const getValor= (key, rowData, modificadorValorCelda) => {
    //console.log("++ getValor");
    //console.log("Key: " + key);

    let valor= "";

    if (key && key.includes("|"))
        valor = getValorMulticampo(key, rowData);
    else {
        if (esForeign(key)) {
            if (esForeign2Nivel(key)) {
                valor = getValorDeForeign2Nivel(key, rowData);
            } else {
                valor = getValorDeForeign(key, rowData);
            }
        } else {
            if (esForeignJPA(key)) {
                valor = getValorPropiedad(rowData, key);
            } else {
                //console.log("NO esForeign");
                valor = rowData[key];
            }
        }
    }

    if (modificadorValorCelda) {
        let newValor= modificadorValorCelda(key, valor, rowData);
        //console.log("Formatter: ", key, " newValor: ", newValor);
        return newValor;
    }
    else
        return valor;
}

export const getValorMulticampo= (key, rowData) => {
    let valor= "";
    let campos= key.split("|");
    campos.forEach((campo, index) => {
        let keyParcial= campo.trim();
        let valorParcial= getValor(keyParcial, rowData);
        if (valorParcial !== "" && valorParcial !== "NO DEFINIDO" ) {
            if (valor !== "")
                valor += " ";
            valor += valorParcial;
        }
    })
    return valor;
}

export const getColorDeColoreador= (coloreador, valor) => {
    if (valor <= coloreador.valorUmbral1)
        return coloreador.color1;
    else
        return coloreador.color2;
}

export const asignarTextAlignPorTipo= (tipo, style) => {
    switch (tipo.toUpperCase()){
        case CELLTIPO_CADENA:
        case CELLTIPO_FOREIGN:
        case CELLTIPO_LISTA: style.textAlign= 'left'; break;
        case CELLTIPO_ENTERO_CENTRO:
        case CELLTIPO_FECHA:
        case CELLTIPO_FECHA_IZQUIERDA:
        case CELLTIPO_FECHAHORA:
        case CELLTIPO_HORA:
        case CELLTIPO_CHORA:
        case CELLTIPO_SINO:
        case CELLTIPO_COLOR: style.textAlign= 'center'; break;
        case CELLTIPO_CANTIDAD:
        case CELLTIPO_MONEDA:
        case CELLTIPO_PORCENTAJE:
        case CELLTIPO_ENTERO:
        case CELLTIPO_FLOTANTE: style.textAlign= 'right'; break;
        case CELLTIPO_IMAGENLISTA: style.textAlign= 'center';
            style.paddingTop= 2;
            style.paddingBottom= 2;
            break;
        default: break;
    }
}

export const getEstilo= (propiedades) => {
    let estilo= {margin: 0, paddingLeft: '4px', paddingRight: '4px', textAlign: 'left', fontSize: FONT_SIZE};

    //Intervalo
    estilo.backgroundColor=  propiedades.rowIdx % 2 == 1 ? COLOR_ROW_IMPAR : COLOR_ROW_PAR;

    //Asignamos estilos de niveles
    if (propiedades.nivel) {
        let nivelValor = propiedades.objeto[propiedades.nivel];
        estilo= getEstiloDeNivelYPie(nivelValor, false, propiedades.tipo);
    }
    else{
        asignarTextAlignPorTipo(propiedades.tipo, estilo);
    }

    if (propiedades.objeto.esPie){
        estilo.backgroundColor = COLOR_ROW_PIE;
    }
    else {
        //Estilizador:
        //console.log(propiedades.columnKey);
        //console.log("propiedades.estilizador: ", propiedades.estilizador);

        //1. EstilizadorRow
        if (propiedades.estilizadorRow) {
            let estiloCalculado = propiedades.estilizadorRow(propiedades.objeto);
            estilo = estiloCalculado ? Object.assign(estilo, estiloCalculado) : estilo;
        }

        //2. Estilizador
        if (propiedades.estilizador) {
            let estiloCalculado = propiedades.estilizador(propiedades.objeto, propiedades.columnKey);
            estilo = estiloCalculado ? Object.assign(estilo, estiloCalculado) : estilo;
        }

        //3. Coloreador:
        if (propiedades.coloreador) {
            let colorFondoColoreador = getColorDeColoreador(propiedades.coloreador, propiedades.valor);
            estilo.backgroundColor = colorFondoColoreador;
        }

        //Celda Seleccionada
        if (propiedades.mostrarFilaActiva &&
            (propiedades.rowEsSeleccionada || propiedades.filaSeleccionada)
        ) {
            estilo.backgroundColor = COLOR_CELL_SELECCIONADA;
        }


        if (propiedades.mostrarCeldaActiva && propiedades.celdaEsSeleccionada) {
            estilo.backgroundColor = COLOR_CELL_SELECCIONADA;
        }
    }

    return estilo;
}


export const getEstiloDeNivelYPie= (nivel, esPie, tipo) => {

    let style = {
        textAlign: 'left',
        backgroundColor: '#ffffff',
        fontSize: FONT_SIZE,
        padding: '4px',
    }
    /*
    if (esPie){
        style= {
            backgroundColor: '#dddddd',
            fontWeight: 'bold',
            textAlign: 'right'
        }
    }
     */
    asignarTextAlignPorTipo(tipo, style);


    if (nivel >= 0) {
        if (nivel === 1) {
            style.backgroundColor = '#aaaaaa';
            style.fontWeight= 'bolder';
        }
        if (nivel === 2) {
            style.backgroundColor = '#dddddd';
            style.fontWeight= 'bold';
        }
        if (nivel === 3) {
            style.fontWeight= 'bold';
        }
    }
    return style;
}


export const getFormatter= (props, resourcesImages, nivel) => {
    //console.log("<<< getFormatter");
    //console.log("props: ", props);
    let valor = getValor(props.column.key, props.row, props.column.modificadorValorCelda);
    let imagenes = props.column.imagenes;
    let propiedades= {
        objeto: props.row,
        valor: valor,
        rowIdx: props.row.rowIdx, //props.rowIdx, Qutaron rowIdx de las props en la 7.0.0 Beta
        celdaEsSeleccionada: props.isCellSelected,
        rowEsSeleccionada: props.isRowSelected, //Para los checks
        estilizador: props.column.estilizador,
        estilizadorRow: props.column.estilizadorRow,
        coloreador: props.column.coloreador,
        filaSeleccionada: props.row.filaSeleccionada,
        mostrarFilaActiva: props.column.mostrarFilaActiva,
        mostrarCeldaActiva: props.column.mostrarCeldaActiva,
        accion: props.column.onAccion,
        imagenes: props.column.imagenes,
        nivel: nivel,
        tipo: props.column.tipo ? props.column.tipo.toUpperCase() : props.column.tipo,
        columnIdx: props.column.idx,
        columnKey: props.column.key,
        valores: props.column.valores,
        modificadorValorCelda: props.column.modificadorValorCelda,
        onDobleClick: props.column.onDobleClick,
        ocultarCeros: props.column.ocultarCeros,
        onModificar: props.column.onModificar,
        onEliminar: props.column.onEliminar,
        listaColores: props.column.listaColores,
        onTooltip: props.column.onTooltip,
        mostrarTooltip: props.column.mostrarTooltip,
        mostrarPopover: props.column.mostrarPopover,
        onCalcularComponentesCelda: props.column.onCalcularComponentesCelda,
    }

    if (valor != null) {
        switch (props.column.tipo.toUpperCase()) {
            case CELLTIPO_CADENA:
                return getCellCadenaRenderer(propiedades);
            case CELLTIPO_MEMO:
                return getCellMemoRenderer(propiedades);
            case CELLTIPO_CADENA_CENTRO:
                return getCellCadenaCentroRenderer(propiedades);
            case CELLTIPO_CADENACENTRO_ACCIONCONDICIONVALOR:
                return getCellCadenaCentroAccionCondicionValorRenderer(props.column.icon, propiedades);
            case CELLTIPO_CADENA_COLORES:
                return getCellCadenaColores(propiedades);
            case CELLTIPO_FECHA:
            case CELLTIPO_FECHA_IZQUIERDA:
                return getCellFechaRenderer(propiedades);
            case CELLTIPO_FECHAHORA:
                return getCellFechaHoraRenderer(propiedades);
            case CELLTIPO_HORA:
                return getCellHoraRenderer(propiedades);
            case CELLTIPO_MONEDA:
                return getCellMonedaRenderer(propiedades);
            case CELLTIPO_PORCENTAJE:
                return getCellPorcentajeRenderer(propiedades);
            case CELLTIPO_ENTERO:
            case CELLTIPO_ENTERO_CENTRO:
                return getCellEnteroRenderer(propiedades);
            case CELLTIPO_COLOR:
                return getCellColorRenderer(propiedades);
            case CELLTIPO_FLOTANTE:
                return getCellFlotanteRenderer(propiedades);
            case CELLTIPO_SINO:
                return getCellSiNoRenderer(propiedades);
            case CELLTIPO_CHORA:
                return getCellCHoraRenderer(propiedades);
            case CELLTIPO_ICONO:
                return getCellIcono(propiedades);
            case CELLTIPO_IMAGENLISTA:
                return getCellImagenLista(propiedades, resourcesImages);
            case CELLTIPO_ESTADOROW:
                return getCellEstadoRowRenderer(propiedades);
            case CELLTIPO_LISTA:
                return getCellLista(propiedades);
            case CELLTIPO_ICONOACCIONCONDICIONVALOR:
                return  getCellIconoAccionCondicionValorRenderer(props.column.icon, propiedades);
            case CELLTIPO_MODIFICARROW:
                return getCellModificarRowRenderer(propiedades);
            case CELLTIPO_ELIMINARROW:
                return getCellEliminarRowRenderer(propiedades);
            case CELLTIPO_FOREIGN:
                return getCellForeignRenderer(propiedades);
            case CELLTIPO_COMPONENTES:
                return getCellComponentes(propiedades);
            default:
                return getCellCadenaRenderer(propiedades);
        }
        return getCellCadenaRenderer(propiedades);
    }
    else {
        if (props.column.tipo) {
            switch (props.column.tipo.toUpperCase()) {
                case CELLTIPO_ESTADOROW:
                    return getCellEstadoRowRenderer(propiedades);
                case CELLTIPO_MODIFICARROW:
                    return getCellModificarRowRenderer(propiedades);
                case CELLTIPO_ELIMINARROW:
                    return getCellEliminarRowRenderer(propiedades);
                case CELLTIPO_ICONOACCION_ELIMINAR:
                    return getCellIconoAccionRenderer("trash", propiedades)
                case CELLTIPO_ICONOACCION_DESCARGAR:
                    return getCellIconoAccionRenderer("download", propiedades)
                case CELLTIPO_ICONOACCION_VER:
                    return getCellIconoAccionRenderer("eye-open", propiedades)
                case CELLTIPO_ICONOACCION_IMPRIMIR:
                    return getCellIconoAccionRenderer("print", propiedades)
                case CELLTIPO_ICONOACCION:
                    return getCellIconoAccionRenderer(props.column.icon, propiedades);
                case CELLTIPO_FOREIGN:
                    return getCellForeignRenderer(propiedades);
                case CELLTIPO_COMPONENTES:
                    return getCellComponentes(propiedades);
                default:
                    return getCellCadenaVaciaRenderer(propiedades);
            }
        }
        else
            return getCellCadenaVaciaRenderer(propiedades);
    }

}

export const getCellEstadoRowRenderer= (propiedades) => {
    //console.log(">> getCellEstadoRowRenderer: ");
    //console.log("propiedades: ", propiedades);

    const estado= propiedades.valor;
    let valor= propiedades.rowIdx+1;
    //console.log("estado: ", estado);
    //console.log("valor: ", valor);
    if (estado){
        switch (estado){
            case "GUARDADO": return (<div style={{backgroundColor: 'green', textAlign: 'center'}}>{valor}</div>); break;
            case "PENDIENTE": return (<div style={{backgroundColor: 'orange', textAlign: 'center'}}>{valor}</div>); break;
            case "ERROR": return (<div style={{backgroundColor: 'red', textAlign: 'center'}}>{valor}</div>); break;
            default: return (<div style={{backgroundColor: 'lightgrey', textAlign: 'center'}}>{valor}</div>); break;
        }
    }
    else {
        return (<div style={{backgroundColor: 'lightgrey', textAlign: 'center'}}>{valor}</div>);
    }
}

export const getCellCadenaVaciaRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    estilo.textAlign= "center";
    return ( <div style={estilo}>-</div> );
}


export const getCellCadenaRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    let valorMostrar= propiedades.valor && propiedades.valor != "" ? propiedades.valor : ""; //"-";
    //console.log("getCellCadenaRenderer ", propiedades.campo, " -> ", valorMostrar);
    if (valorMostrar !== ""){
        let mostrarTooltip= propiedades.mostrarTooltip ? propiedades.mostrarTooltip(propiedades.objeto, propiedades.rowIdx) : true;
        if (propiedades.onTooltip && mostrarTooltip)
            return (<div style={estilo}>
                <Tooltip className={Classes.TOOLTIP2_INDICATOR} content={propiedades.onTooltip(propiedades.objeto, propiedades.rowIdx)}>
                    <div style={estilo} onClick={() => dobleclick(propiedades)}> {valorMostrar} </div>
                </Tooltip>
            </div>);
        else
            return (<div style={estilo} onClick={() => dobleclick(propiedades)}> {valorMostrar} </div>);
    }
    else {
        return (<div style={estilo}><span>&nbsp;</span></div>);
    }
}

export const getCellMemoRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    let valorMostrar= propiedades.valor && propiedades.valor != "" ? propiedades.valor : ""; //"-";
    console.log("getCellCadenaRenderer ", propiedades.campo, " -> ", valorMostrar);
    if (valorMostrar !== ""){
        console.log("RENDER MEMO!");
        return (<div className="multi-line-cell"
            style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            overflow: "visible",
            display: "block",
            height: "auto"}}>
            {valorMostrar}
        </div>);
    }
    else {
        return (<div style={estilo}><span>&nbsp;</span></div>);
    }
}


export const getCellCadenaCentroRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'center';
    let valorMostrar= propiedades.valor && propiedades.valor != "" ? propiedades.valor : "";
    if (valorMostrar !== "")
        //return ( <div style={estilo}> {valorMostrar} </div> );
        return (<div style={estilo} onClick={() => dobleclick(propiedades)}> {valorMostrar} </div>);
    else
        return (<div style={estilo}><span>&nbsp;</span></div>);
}

export const getCellFechaRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'center';
    let cadFecha= getFormattedDateFromTimestamp(propiedades.valor);
    if (cadFecha === '01/01/1900')
        cadFecha= "-";
    return ( <div style={estilo}>{cadFecha}</div>);
}

export const getCellFechaHoraRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'center';
    return ( <div style={estilo}>{getFormattedDateTimeFromTimestamp(propiedades.valor)}</div>);
}
export const getCellHoraRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'center';
    return ( <div style={estilo}>{getFormattedTimeFromTimestamp (propiedades.valor)}</div>);
}

export const getCellPorcentajeRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'right';
    return ( <div style={estilo}>{propiedades.valor}%</div>);
}

export const getCellEnteroRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    //estilo.textAlign= 'right';

    //console.log("getCellEnteroRenderer");
    //console.log("propiedades: ", propiedades);
    //console.log("estilo: ", estilo);

    if (!propiedades.ocultarCeros || propiedades.valor != 0)
        return (<div style={estilo} onClick={() => dobleclick(propiedades)}> {propiedades.valor} </div>);
    else
        return ( <div style={estilo}><span>&nbsp;</span></div>);
}

export const getCellMonedaRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'right';
    let valor= propiedades.valor;
    let tipo= typeof valor; //=== 'number'
    //console.log("valor: ", valor);
    //console.log("tipo: ", tipo);
    if (valor != undefined && valor != null) {
        switch (tipo) {
            case "number":
                let valorFormateado= valor.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
                return (<div style={estilo}>{valorFormateado}</div>);
            case "string":
                return (<div style={estilo}>{valor}€</div>);
            default:
        }
    }
    else
        return ( <div style={estilo}><span>&nbsp;</span></div>);
}

export const getCellFlotanteRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'right';
    return ( <div style={estilo}>{propiedades.valor}</div>);
}

export const getCellSiNoRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'center';
    let valorMostrar= propiedades.valor ? "Sí" : "No";
    if (typeof propiedades.valor === 'string' || propiedades.valor instanceof String){
        if (propiedades.valor.toUpperCase() === "TRUE")
            valorMostrar= "Sí";
        if (propiedades.valor.toUpperCase() === "FALSE")
            valorMostrar= "No";
    }
    return (<div style={estilo} onClick={() => dobleclick(propiedades)}> {valorMostrar} </div>);
}

export const getCellCHoraRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'center';
    return ( <div style={estilo}>{propiedades.valor.horaMinutosDescriptivo}</div>);
}

export const getCellColorRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    estilo.backgroundColor= propiedades.valor;
    estilo.textAlign= 'center';
    return ( <div style={estilo} onClick={() => dobleclick(propiedades)}>{propiedades.valor}</div>);
}

export const getCellIcono= (propiedades) => {
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'center';
    return ( <div style={estilo}><Icon icon={propiedades.valor}/></div>);
}

export const getCellIconoAccionRenderer= (icon, propiedades) => {
    //console.log("getCellIconoAccionRenderer: ");
    //console.log("icon: ", icon);
    //console.log("propiedades: ", propiedades);
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'center';
    if (propiedades.accion) {
        return (<div style={estilo}><Icon icon={icon} onClick={() => propiedades.accion(propiedades.objeto)}/></div>);
    }
    else
        return ( <></> );

}
export const getCellIconoAccionCondicionValorRenderer= (icon, propiedades) => {
    //console.log("IconoAccionCondicionValorRenderer");
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'center';
    if (propiedades.accion && propiedades.valor) {
        return (<div style={estilo}><Icon icon={icon}
                                          onClick={() => propiedades.accion(propiedades.objeto, propiedades.rowIdx)}/>
        </div>);
    }
    else
        return ( <></> );
}

export const getCellCadenaCentroAccionCondicionValorRenderer= (icon, propiedades) => {
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'center';
    let valorMostrar= propiedades.valor && propiedades.valor != "" ? propiedades.valor : "";
    if (valorMostrar !== "" && propiedades.accion && propiedades.valor) {
        return (<div style={estilo} onClick={() => propiedades.accion(propiedades.objeto, propiedades.rowIdx)}>
            <Icon icon={icon}/>{valorMostrar}
        </div>);
    }
    else
        return (<div style={estilo}><span>&nbsp;</span></div>);
}

export const getCellCadenaColores= (propiedades) => {
    let estilo = getEstilo(propiedades);
    estilo.textAlign = 'center';

    if (propiedades.valor !== "") {
        let arrayComponentes = transformarCadenaColores(propiedades.valor, propiedades.listaColores, ",");
        let mostrarTooltip = propiedades.mostrarTooltip ? propiedades.mostrarTooltip(propiedades.objeto, propiedades.rowIdx) : true;

        if (propiedades.onTooltip && mostrarTooltip)
            return (<div style={estilo}>
                <Tooltip className={Classes.TOOLTIP2_INDICATOR}
                         content={propiedades.onTooltip(propiedades.objeto, propiedades.rowIdx)}>
                    <div>{arrayComponentes.map((componente) => {
                        return componente
                    })} </div>
                </Tooltip>
            </div>);
        else
            return (
                <div style={estilo}>
                    {arrayComponentes.map((componente) => {
                        return componente
                    })}
                </div>
            )
    } else {
        return (<div style={estilo}><span>&nbsp;</span></div>);
    }
}

export const getCellComponentes= (propiedades) => {
    let estilo= getEstilo(propiedades);
    //estilo.textAlign= 'center';
    estilo.textAlign= 'left';

    //console.log("getCellComponentes");
    //console.log("propiedades: ", propiedades);
    //console.log("propiedades.onCalcularComponentesCelda: ", propiedades.onCalcularComponentesCelda);

    let arrayComponentes= [];
    if (propiedades.onCalcularComponentesCelda)
        arrayComponentes= propiedades.onCalcularComponentesCelda(propiedades.objeto, propiedades.columnKey, propiedades.rowIdx);
    let mostrarTooltip= propiedades.mostrarTooltip ? propiedades.mostrarTooltip(propiedades.objeto, propiedades.columnKey, propiedades.rowIdx) : true;
    if (propiedades.onTooltip && mostrarTooltip)
        return (<div style={estilo}>
            <Tooltip className={Classes.TOOLTIP2_INDICATOR} content={propiedades.onTooltip(propiedades.objeto, propiedades.rowIdx)}>
                <div>
                    {arrayComponentes.map((componente) => { return componente  })}
                </div>
            </Tooltip>
        </div>);
    else
        return(
            <div style={estilo}>
                {arrayComponentes.map((componente) => {
                    return componente
                })}
            </div>
        )
}


export const getCellImagenLista= (propiedades, resourcesImages) => {
    //console.log("getCellIconoAccionRenderer: ");
    //console.log("propiedades: ", propiedades);
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'center';

    if (propiedades.valor != undefined && propiedades.valor != null) {
        if (propiedades.imagenes) {
            let imagenesEncontradas = filtrarConNombreCampo(propiedades.imagenes, "valor", propiedades.valor);
            if (imagenesEncontradas && imagenesEncontradas.length > 0) {
                let imagen= imagenesEncontradas[0].imagen;
                if (imagen && imagen != "")
                    imagen = "./" + imagen;
                else
                    imagen= "./icon_vacio.png";
                let imagenSrc = resourcesImages(imagen);
                //!Hay que meterlo dentro de un React.Fragment para que no de un warning por una propiedad.
                return <div style={estilo}>
                    <React.Fragment>
                        <img src={imagenSrc} width={24} alt={propiedades.valor.toString()}/>
                    </React.Fragment>
                </div>;

            } else
                return (<div style={estilo}>{propiedades.valor}</div>)
        } else
            return (<div style={estilo}>{propiedades.valor}</div>)
    }
    else{
         return ( <div style={estilo}></div>)
    }

}

export const getCellLista= (propiedades) => {
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'center';
    let elemento= primerElementoCodigo(propiedades.valores, propiedades.valor);
    let valorMostrar=  elemento ? elemento.nombre : "-";
    if (valorMostrar !== "")
        return (<div style={estilo} onClick={() => dobleclick(propiedades)}> {valorMostrar} </div>);
    else
        return (<div style={estilo}><span>&nbsp;</span></div>);
}

export const getCellForeignRenderer= (propiedades) => {
    let estilo= getEstilo(propiedades);
    let valorMostrar= propiedades.valor && propiedades.valor != "" ? propiedades.valor : "-";
    if (valorMostrar !== "")
        return (<div style={estilo} onClick={() => dobleclick(propiedades)}> {valorMostrar} </div>);
    else
        return (<div style={estilo} onClick={() => dobleclick(propiedades)}><span>&nbsp;</span></div>);
}

export const getCellModificarRowRenderer= (propiedades) => {
    //console.log(">> getCellModificarRowRenderer: ");
    //console.log("propiedades: ", propiedades);
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'center';
    return (<div style={estilo}><Icon icon="edit"
                                      onClick={() => propiedades.onModificar(propiedades.objeto)}/>
    </div>);
}

export const getCellEliminarRowRenderer= (propiedades) => {
    console.log(">> getCellEliminarRowRenderer: ");
    //console.log("propiedades: ", propiedades);
    let estilo= getEstilo(propiedades);
    estilo.textAlign= 'center';
    return (<div style={estilo}><Icon icon="trash"
                                      onClick={() => propiedades.onEliminar(propiedades.objeto)}/>
    </div>);
}



// DOBLE CLICK
let clicked= false;
const dobleclickOld= (propiedades) => {
    //console.log("Formatter : DobleClick");
    //console.log("Propiedades: ", propiedades);
    if(clicked) {
        clicked= false;
        //console.log("clicked");
        //console.log("propiedades.onDobleClick: ", propiedades.onDobleClick);
        propiedades.onDobleClick && propiedades.onDobleClick(propiedades);
        //callback && callback(key, row);
        //callback();
    } else {
        clicked = true;
    }
    setTimeout(function(){
        //Añadido 12/07/2023
        //Para detectar un simple click
        if (clicked) {
            //Si tiene popup en las propiedades
            if (propiedades.onTooltip)
                propiedades.mostrarPopover && propiedades.mostrarPopover(propiedades.objeto, 0, propiedades.onTooltip);
            propiedades.onClick && propiedades.onClick(propiedades);
        }
        clicked = false
    }, 333); //detect fast clicks (333ms)

}

const dobleclick= (propiedades) => {
    //console.log("Formatter : DobleClick");
    //console.log("propiedades.onDobleClick: ", propiedades.onDobleClick);
    propiedades.onDobleClick && propiedades.onDobleClick(propiedades);

}